import { useEffect, useState } from "react"
import { getPaletteObject } from "../../services/algoliaPaletteService";
import { AlgoliaPaletteHit } from "../../types/AlgoliaTypes";
import { Link } from "react-router-dom";
import { PLACEHOLDER_IMAGE } from "../../data/constants";
import SteelcaseImage from "../layout/SteelcaseImage/SteelcaseImage";

interface FeaturedInCardProps {
    palette_id: string;
}
export default function FeaturedInCard({palette_id}: FeaturedInCardProps) {

    const [paletteData, setPaletteData] = useState<AlgoliaPaletteHit>();

    const retrievePalette = async (palette_id: string) => {
        if(palette_id) {
            const paletteObj = await getPaletteObject(palette_id)
            setPaletteData(paletteObj); 
        }
    }

    useEffect(() => {
        retrievePalette(palette_id);
    }, [])

    return (
        <div className={"finish-featured-in__container"}>
            <div className={"finish-featured-in__card-image"}>
                <SteelcaseImage src={paletteData && paletteData.assetRelationships && paletteData.assetRelationships[0] ? paletteData?.assetRelationships[0] : PLACEHOLDER_IMAGE} />
            </div>
            <div className={"finish-featured-in__card-content"}>
                <div className={"finish-featured-in__card-name"}>
                    {paletteData?.name}
                </div>
                <div className={"finish-featured-in__card-description"}>
                    {paletteData?.description}
                </div>
                {<Link className={"finish-featured-in__link-btn"} to={`../palettes/${paletteData?.routerValue}`}>{window?.steelcase_i18n["steelcase-finish-library"].palettes?.view_palette || "View Palette"} <span className={"finish-featured-in__surface-caret"}></span></Link>}
            </div>
        </div>
    )
}